import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M9 12l2 2l4 -4","key":"svg-1"}]]

const IconCircleCheck = createReactComponent('outline', 'circle-check', 'CircleCheck', __iconNode);

export default IconCircleCheck;